module.exports = __webpack_public_path__ + "static/media/enconcept.c81ece69.png";